exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (min-width: 1024px) {\n.contributor-top-posts[data-v-70c19966] {\n    width: calc((100vw - 14rem) / 2);\n}\n}\n", ""]);

// exports
